export const TEXTS = {
  SBER_BUSINESS_ONLINE_PAY_BUTTON_TEXT: 'Оплатить',
  SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_WARNING_TEXT:
    'Для оплаты нужно подписать согласие на списание со счёта СберБизнес.',
  SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_BUTTON_TEXT: 'Оплатить через СберБизнес',
  SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_INFO_TEXT: (payerAccount: string) =>
    `Согласие на списание средств СберБизнес подписано. Списание будет происходить со счета № ****${payerAccount}`,
};
